export default {"src":"nextstatic/1faf8464/_next/static/media/background.c6579d36.svg","height":128,"width":388};